<template>
  <div class="complete-page">
    <div class="complete-card">
      <!-- ICON -->
      <div class="icon-wrapper">
        <slot name="icon">
          <!-- default success icon -->
          <svg width="80" height="100" viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M34.75 80L63 51.75L55.75 44.5L34.625 65.625L24.125 55.125L17 62.25L34.75 80ZM10 100C7.25 100 4.89583 99.0208 2.9375 97.0625C0.979167 95.1042 0 92.75 0 90V10C0 7.25 0.979167 4.89583 2.9375 2.9375C4.89583 0.979167 7.25 0 10 0H50L80 30V90C80 92.75 79.0208 95.1042 77.0625 97.0625C75.1042 99.0208 72.75 100 70 100H10ZM45 35H70L45 10V35Z" fill="#223F80"/>
          </svg>
        </slot>
      </div>

      <!-- TEXT -->
      <h2 class="title">
        {{ title }}
      </h2>
      <p class="description">
        {{ description }}
      </p>

      <!-- VISION+ BENEFIT SECTION -->
      <div class="visionplus-section" v-if="banner">
        <div class="visionplus-header">
          <div class="vision-logo">
            <img :src="banner?.image_url" alt="vision-logo" />
          </div>
          <div class="visionplus-title" v-html="banner?.title"/>
        </div>

        <div class="visionplus-content">
          <div class="content-subtitle" v-html="banner?.description"/>

          <ol class="steps-list">
            <li class="step-item" v-for="bn, i in bannerChild" :key="i">
              <span class="step-number">{{ i + 1 }}</span>
              <div class="step-text" v-html="bn?.description" />
            </li>
          </ol>
        </div>
      </div>

      <!-- ACTION -->
      <button class="primary-btn" @click="onAction">
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import { bannerCode } from '@/store'

export default {
  name: 'RegisterComplete',
  props: {
    title: {
      type: String,
      default: 'Pendaftaran berhasil'
    },
    description: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'Kembali ke Dashboard'
    }
  },
  data () {
    return {
      banner: null
    }
  },
  methods: {
    onAction () {
      this.$emit('action')
    },

    async getBanner() {
      try {
        const res = await this.$store.dispatch('getBanners', bannerCode.bnrKtaSuccessRgstHtml)
        this.banner = res?.data
      } catch (error) {
        this.logger('Error loading job: ', err)
      }
    },
  },

  computed: {
    bannerChild() {
      return JSON.parse(this.banner?.child)
    }
  },

  async mounted() {
    await Promise.all([this.getBanner()])
  }
}
</script>

<style scoped>
.complete-page {
  height: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.complete-card {
  width: 100%;
  max-width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* ICON */
.icon-wrapper {
  margin-bottom: 24px;
}

/* TITLE */
.title {
  font-size: 22px;
  font-weight: 700;
  color: #2b2f38;
  margin-bottom: 12px;
}

/* DESCRIPTION */
.description {
  font-size: 14px;
  color: #667085;
  line-height: 1.5;
  margin-bottom: 32px;
  max-width: 420px;
}

/* VISION+ SECTION */
.visionplus-section {
  width: 100%;
  max-width: 800px;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  text-align: left;
}

.visionplus-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E5E7EB;
}

.vision-logo {
  flex-shrink: 0;
}

.visionplus-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  line-height: 1.4;
}

.visionplus-content {
  padding: 0;
}

.content-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 16px 0;
}

.steps-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.step-number {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background: #ffffff;
  border: 1px solid #D1D5DB;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.step-text {
  flex: 1;
  font-size: 14px;
  color: #4B5563;
  line-height: 1.5;
}

/* BUTTON */
.primary-btn {
  width: 100%;
  max-width: 800px;
  padding: 14px 16px;
  border-radius: 8px;
  border: none;
  background: #465F97;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.1s;
}

.primary-btn:hover {
  background: #3d5283;
}

.primary-btn:active {
  transform: scale(0.99);
}

/* MOBILE TWEAK */
@media (max-width: 768px) {
  .title {
    font-size: 20px;
  }

  .description {
    font-size: 13px;
  }

  .complete-page {
    padding: 16px;
  }

  .complete-card {
    max-width: 100%;
  }

  .visionplus-section {
    padding: 20px;
  }

  .visionplus-header {
    gap: 12px;
  }

  .visionplus-title {
    font-size: 15px;
  }

  .vision-logo svg {
    width: 36px;
    height: 36px;
  }

  .content-subtitle {
    font-size: 13px;
  }

  .step-text {
    font-size: 13px;
  }
}
</style>
